import useShops from '@activities/shops/ShopListActivity/components/ShopList/hooks/useShops';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { RootState } from '@store/store';
import { useSelector } from 'react-redux';

const TestActivity : ActivityComponentType = () => {
    const state = useSelector((s: RootState) => s.item);
    const { shops } = useShops({
        locationAgreed: false, ready: true,
    });
    return (
        <AppScreen>
            {shops?.map((shop) => (
                <div key={shop.id}>
                    {shop.name}
                </div>
            ))}
            <br/>
            {JSON.stringify(state)}
        </AppScreen>
    );
};

export default TestActivity;
